<template>
    <div>
        <div class="pf-medium half-vip-btn" :class="{'half-vip-btn-red':h_btn_color}" @click="clickPay" v-html="formatHtmlBtnstr()"></div>
    </div>
</template>
<script>
    import { fenToYuan, getDeepVal, toast } from '@kkmh/utils'
    import { setComboAssign } from '../js/common'
    import { doTrackClick } from "../js/track";
    export default {
        name: 'PayButton',
            data () {
            return {
                h_btn_color:false,
                btn_name : '',
            }
        },
        props: {
            h_visible_hascoupon:false,
            h_data_userinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
            h_data_goodinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
            j_req:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        methods:{
            //打开会员相关h5页面
            clickPay() {
                (async () => {
                    doTrackClick(this.btn_name, this.j_req);
                    let free_encrypt_str = getDeepVal(this.h_data_goodinfo,'comboinfo.free_encrypt_str', '');
                    if (free_encrypt_str) {
                        let errormessage = await setComboAssign(this.j_req, free_encrypt_str);
                        if (errormessage) {
                            toast(errormessage);
                            return null;
                        }
                    }
                    this.$emit('clickJumpPay',this.btn_name);
                })();
            },
            formatHtmlBtnstr() {
                let btn = getDeepVal(this.h_data_goodinfo,'words_info.promotion_btn_text','');
                if (btn) {
                    this.h_btn_color = true;
                    this.btn_name = btn;
                    return '<span class="half-vip-btn-fy">'+btn+'</span>';//免费体验7天
                }
                this.h_btn_color = false;
                let v0 = getDeepVal(this.h_data_goodinfo,'price.mark_price',0);
                let v1 = getDeepVal(this.h_data_goodinfo,'price.real_price',0);
                let v2 = this.h_data_goodinfo.couponprice || 0;
                let v3 = fenToYuan(v1 - v2);
                if (v2>0 && this.h_visible_hascoupon){//iap支付不能显示优惠券
                    this.btn_name = '立即支付';
                    return '<div class="half-vip-btn-p">立即支付<span>￥'+v3+'</span><span>￥'+fenToYuan(v1)+'</span></div>';
                } else {
                    if (getDeepVal(this.h_data_userinfo,'vip_user.has_charge_record','')) {
                        this.btn_name = '立即开通';
                        return '<span>立即开通</span>';
                    } else {
                        this.btn_name = '立即续费';
                        return '<span>立即续费</span>';
                    }
                }
            },
        },
    }
</script>
<style lang="scss">
@import "../../../assets/styles/mixins.scss";
.pop-wrap{
    .half-vip-btn-red{
        color:#fff;background-image: linear-gradient(135deg, #FF257F 0%, #FF0047 100%);
    }
    .half-vip-btn{
        font-weight:600!important;width: vws(718px);height: vws(88px);border-radius: vws(80px);margin: vws(31px) auto 0;color: #442509;font-size: vws(32px);display: flex;justify-content: center;align-items: center;background:#FDE23D;
        .half-vip-btn-p{
            span:first-child{color: #442509;padding-right: vws(8px);}
            span:last-child{font-size:vws(30px);color: rgba(68,37,9,.4);text-decoration: line-through;}
        }
        .half-vip-btn-fy{color:#fff;}
    }
}

</style>



// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/PayButton.vue